
import ImageCarousel from "@/components/business/ImageCarousel"
import BusinessHeader from "@/components/business/BusinessHeader"
import BusinessInfo from "@/components/business/BusinessInfo"
import Button from "@/components/base/Button"

export default {
    components: {
        BusinessInfo,
        BusinessHeader,
        ImageCarousel,
        Button,
        BusinessLocation: () =>
            import("@/components/business/BusinessLocation"),
    },
    props: {
        business: {
            type: Object,
            required: true,
        },
    },
    computed: {
        logo() {
            return this.$getImage({
                image: this.business.logo,
                preferedSize: "3",
            })
        },
        showBusinessMap() {
            return this.business.primary_address?.street?.length > 0
        },
    },
}
